import { Milestone } from "../collaborations/CollaborationTypes";

export interface CampaignRequirement {
    follower_count: number;
}

interface Brand {
    name: string;
    website_url: string;
    description: string;
    category: string;
}

export interface Campaign {
    uuid: string;
    name: string;
    hero_img_url: string;
    gender_name: string;
    strategy: string;
    strategy_name?: string;
    status?: string;
    description?: string;
    niches?: string[];
    niche_names?: string[];
    speciality_niches?: string[];
    speciality_niche_names?: string[];
    posted_on?: string;
    budget?: string;
    is_pro?: boolean;
    barter_budget?: string | null,
    barter_reimbursement?: boolean,
    created?: string;
    gallery_images?: string[];
    requirement: CampaignRequirement;
    requirements?: Requirements,
    brand?: Brand;
    connection_required: boolean;
    platform: string;
}

export interface Requirements {
    gender?: "A" | "F" | "M",
    gender_name?: string,
    follower_count?: {
        min: number
    },
    niches?: string[],
    cities?: string[],
    regions?: string[],
    age?: {
        min?: number | null,
        max?: number | null
    },
    audience_cities?: string[],
    audience_age_groups?: any[],
    audience_gender?: "A" | "F" | "M",
    audience_gender_name?: string,
    languages?: string[];
    creator_count?: {
        min?: number | null,
        max?: number | null
    };
    creator_bucket: string
}

export const CAMPAIGN_REQUIREMENTS_LABEL = {
    gender : "Influencer's Gender",
    follower_count : "Follower Count",
    niches : "Niche",
    languages : "Language",
    cities : "Influencer's Location",
    regions : "Influencer's Region",
    age : "Influencer's Age",
    audience_cities : "Audience Location",
    audience_age_groups : "Audience Age",
    audience_gender : "Audience Gender"
}

export interface Campaigns {
    count: number,
    items: Campaign[]
}

export interface CampaignData {
    share_url: string,
    campaign: Campaign,
    requirement: CampaignRequirement,
    brand: Brand,
    milestones?: Milestone[]
}

export interface ApplicationData {
    require_location: boolean,
    application: Application | null,
    potential_earning: PotentialEarning,
    can_apply?: boolean
    match?: {
        requirement_match?: number,
        requirement_specifications?: Record<string, any>,
        requirement_matches?: Record<string, {
            name: string,
            type: string,
            match: boolean
        }>,
        authenticity_score?: string
    }
    is_invited?: boolean,
    social_account?: {
        uuid: string,
    }
    seat_left?: number,
    application_count?: number,
    acceptance_probability?: {
        current: number,
        pro: number
    },
    upgrade_to_pro?: boolean,
    questions?: ScreeningQuestion[]
}

export enum ScreeningQuestionType {
    TEXT = 'text',
    BINARY = 'binary',
    CHOICE = 'choice'
}

export interface ScreeningQuestion {
    id: number,
    question: string,
    type: ScreeningQuestionType,
    options?: string[]
}

export interface Application {
    [key: string]: any
}

interface PotentialEarning {
    min: number,
    max: number
}

export interface ApplicationStatus {
    status: 'APPLIED' | 'FAILED' | 'PENDING' | 'NOT_APPLIED',
    message?: string
}